var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333333, 1.333333)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666667,6 C12.992,6 13.27,5.76533333 13.324,5.444 C13.378,5.124 13.192,4.81066667 12.8846667,4.70466667 L0.884666667,0.600666667 C0.62,0.508666667 0.325333333,0.592666667 0.149333333,0.81 C-0.0273333333,1.02666667 -0.0493333333,1.33266667 0.0953333333,1.57266667 L2.55733333,5.676 C2.678,5.87666667 2.89466667,6 3.12866667,6 L12.6666667,6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12866667,7.33333333 C2.894,7.33333333 2.67733333,7.45733333 2.55733333,7.656 L0.0946666667,11.7606667 C-0.0493333333,12 -0.0273333333,12.306 0.149333333,12.5233333 C0.326,12.7406667 0.62,12.824 0.885333333,12.7326667 L12.8853333,8.63 C13.1926667,8.52333333 13.3786667,8.21 13.3246667,7.88933333 C13.2706667,7.56733333 12.9926667,7.33333333 12.6666667,7.33333333 L3.12866667,7.33333333 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.87865f2dd2b55ddfe1622e1cc66c2e49.svg";
export { ForwardRef as ReactComponent };